import { Tag } from "antd";
import moment from "moment";

export const DeletedAdminColumns = ({ reactivate = (f) => f }) => [
  {
    title: "Full Name",
    render: (record) => (
      <span>
        {record.fullName ||
          `${record.firstName ?? ""} ${record.lastName ?? ""}`.trim() ||
          "N/A"}
      </span>
    ),
    ellipsis: true,
  },
  {
    title: "Email",
    dataIndex: "email",
    ellipsis: true,
  },
  {
    title: "Status",
    dataIndex: "status",
    render: (status) => (
      <Tag
        style={{
          backgroundColor: "#fee2e2",
          color: "#991b1b",
          border: "none",
        }}
      >
        {status || "DELETED"}
      </Tag>
    ),
    ellipsis: true,
  },
  {
    title: "Roles",
    dataIndex: "roles",
    render: (roles) => {
      if (!roles || !Array.isArray(roles) || roles.length === 0) {
        return (
          <Tag style={{ border: "none", backgroundColor: "rgba(0,0,0,0.04)" }}>
            N/A
          </Tag>
        );
      }
      return (
        <div style={{ display: "flex", flexWrap: "wrap", gap: "4px" }}>
          {roles.map((role, index) => {
            const label = typeof role === "string" ? role : role?.name;
            return (
              <Tag
                key={index}
                style={{
                  padding: "2px 8px",
                  borderRadius: "6px",
                  fontSize: "11px",
                  backgroundColor: "rgba(0,0,0,0.04)",
                  border: "none",
                  fontWeight: 500,
                }}
              >
                {(label || "")
                  .replace(/_/g, " ")
                  .replace(/\b\w/g, (l) => l.toUpperCase())}
              </Tag>
            );
          })}
        </div>
      );
    },
  },
  {
    title: "Deleted At",
    dataIndex: "deletedAt",
    render: (deletedAt, record) => {
      const value = deletedAt || record.updatedAt || record.createdAt;
      return value ? moment(value).format("YYYY-MM-DD HH:mm") : "N/A";
    },
    ellipsis: true,
  },
  {
    title: "Action",
    render: (record) => (
      <button
        onClick={() => reactivate(record)}
        style={{
          backgroundColor: "#27AE60",
          color: "#fff",
          border: "none",
          borderRadius: "4px",
          padding: "4px 12px",
          fontSize: "12px",
          fontWeight: 500,
          cursor: "pointer",
          transition: "background 0.2s",
        }}
        onMouseOver={(e) =>
          (e.currentTarget.style.backgroundColor = "#219653")
        }
        onMouseOut={(e) =>
          (e.currentTarget.style.backgroundColor = "#27AE60")
        }
      >
        Reactivate
      </button>
    ),
    ellipsis: true,
  },
];
